export default {"src":"/_next/static/media/contact.08641141.svg","height":151,"width":207,"blurWidth":0,"blurHeight":0};